import type {
  SalesChannel,
  SalesChannelInfo,
  TicketProduct
} from 'Services/SalesManagement/Features/TicketSale/types'
import { createBaseApi } from 'Util/ApiClient'

export const salesChannelApi = createBaseApi({
  reducerPath: 'salesChannelApi',
  keepUnusedDataFor: 10,
  tagTypes: []
}).injectEndpoints({
  endpoints: builder => ({
    getSingleSalesChannelForAuthority: builder.query<SalesChannel, { authorityCode: string }>({
      query: ({ authorityCode }) => `/api/v1/sales-channels/for-authority/${authorityCode}/`
    }),
    getSingleSalesChannelInfo: builder.query<SalesChannelInfo, { salesChannelId: string }>({
      query: ({ salesChannelId }) => `/api/v1/sales-channels/${salesChannelId}/info/`
    }),
    getSalesChannelProductsByAgeGroup: builder.query<
      TicketProduct[],
      { salesChannelId: string; ageGroupId: number }
    >({
      query: ({ salesChannelId, ageGroupId }) => ({
        url: `/api/v1/sales-channels/${salesChannelId}/products/${ageGroupId}/`
      })
    })
  })
})

export const {
  useGetSingleSalesChannelForAuthorityQuery,
  useGetSingleSalesChannelInfoQuery,
  useGetSalesChannelProductsByAgeGroupQuery
} = salesChannelApi
